import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" || u.role === "manager" ? "/admin" : "/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <div className="bg-white border border-[#E8E4D9] rounded-2xl p-8">
        <h1 className="text-3xl font-bold tracking-tight text-[#1A231C] font-display">Welcome back</h1>
        <p className="text-[#5C665D] mt-2">Login to your account.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]"
          />
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]"
          />
          {error && (
            <p data-testid="login-error" className="text-sm text-[var(--brand-accent)]">
              {error}
            </p>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[var(--brand-primary)] text-white rounded-lg px-6 py-3 font-medium hover:bg-[var(--brand-primary-hover)] transition-colors disabled:opacity-60"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <p className="text-sm text-[#5C665D] mt-5 text-center">
          No account?{" "}
          <Link to="/register" data-testid="go-register" className="text-[var(--brand-primary)] font-medium">
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}
